<template>
  <div>
    <header id="header" class="d-flex align-items-center" :class="{ 'header-top': isActive }">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="logo" v-clickoutside="handleClickOutside" @click="codeImageClick">
          <picture class="display-inline-block">
            <source media="(max-width: 768px)" srcset="@/assets/img/md/logo.png" />
            <source media="(min-width: 768px)" srcset="@/assets/img/lg/logo.png" />
            <img src="@/assets/img/lg/logo.png" class="image-width-100 logo-image" />
          </picture>
          <img src="@/assets/img/common/code/code.png" class="code-image" />
          <div class="code-image-box" v-show="codeImageShow">
            <img src="@/assets/img/common/code/code.png" />
          </div>
        </div>

        <nav id="navbar" class="navbar" :class="{ 'navbar-mobile': clickNav }">
          <ul>
            <li v-for="item in navList" :key="item.id" :class="item.children ? 'dropdown' : ''">
              <a class="nav-link scrollto" v-if="!item.children" @click="selectNav(item.path)" :class="mainMenu === item.path ? 'active' : ''" href="#">{{ item.title }}</a>
              <a v-if="item.children" class="nav-link scrollto" @click="childrenClick()" :class="mainMenu === item.path ? 'active' : ''" href="#">{{ item.title }}<i class="bi bi-chevron-down"></i></a>
              <ul v-if="item.children" :class="showChiledren ? 'dropdown-active' : ''">
                <li v-for="ch in item.children" :key="ch.id" :class="subMenu === ch.path ? 'nav-link-active' : ''">
                  <a href="#" @click="selectNav(item.path, ch.path)">{{ ch.title }}</a>
                </li>
              </ul>
            </li>
          </ul>
          <i class="bi bi-list mobile-nav-toggle" @click="mobileClick()"></i>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e)
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  },
}
export default {
  name: 'Header',
  components: {},
  props: {},
  data() {
    return {
      isActive: false,
      clickNav: false,
      showChiledren: false,
      navList: [],
      codeImageShow: false,
    }
  },
  computed: {
    ...mapState({
      mainMenu: (state) => state.mainMenu,
      subMenu: (state) => state.subMenu,
    }),
  },
  watch: {
    // 禁止页面滑动/出现滚动条
    clickNav(val) {
      window.eventBus.$emit('navShow', val)
    },
  },
  directives: { clickoutside },
  methods: {
    childrenClick() {
      this.showChiledren = !this.showChiledren
    },
    mobileClick() {
      this.clickNav = !this.clickNav
    },
    selectNav(dhVal, val) {
      console.log(dhVal, val)
      this.$store.dispatch('setMainMenu', dhVal)
      this.clickNav = false
      this.$store.dispatch('setSubMenu', val ? val : '')
      this.$router.push({ path: val ? val : dhVal })
    },
    handleScroll() {
      // 滚动关闭二维码
      this.codeImageShow = false
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 40) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },
    init() {
      this.navList = [
        {
          id: 1,
          path: '/home',
          title: '首页',
        },
        {
          id: 2,
          path: '/about',
          title: '关于我们',
        },
        {
          id: 3,
          path: '/case',
          title: '成功案例',
          children: [
            {
              id: 31,
              path: '/case/opticalModule',
              title: '光模块云编写器',
            },
            {
              id: 32,
              path: '/case/hlx',
              title: '海图系统',
            },
            {
              id: 33,
              path: '/case/equipmentRepair',
              title: '设备维修保养',
            },
            {
              id: 34,
              path: '/case/orderManage',
              title: '订单管理系统',
            },
            {
              id: 35,
              path: '/case/secure',
              title: '企业管理App',
            },
            {
              id: 36,
              path: '/case/ehs',
              title: '职业健康管理系统',
            },
            {
              id: 37,
              path: '/case/electromagneticVehicle',
              title: '电磁车载巡检系统',
            },
            {
              id: 38,
              path: '/case/muBang',
              title: '生物安全',
            },
            {
              id: 39,
              path: '/case/platForm',
              title: '用户统一平台',
            },
            {
              id: 40,
              path: '/case/spectroGraph',
              title: '频谱仪软件',
            },
          ],
        },
        {
          id: 4,
          path: '/fidc',
          title: 'FIDC',
        },
      ]
    },
    codeImageClick() {
      this.codeImageShow = !this.codeImageShow
    },
    handleClickOutside() {
      this.codeImageShow = false
    },
  },
  created() {
    this.init()
    let arr = ['http://www.netluc.com', 'http://www.netluc.com/#/home']
    if (arr.indexOf(window.location.href) === -1) {
      this.$store.dispatch('setMainMenu', '/home')
      this.$store.dispatch('setSubMenu', '')
    } else {
      this.$router.push({ path: this.subMenu ? this.subMenu : this.mainMenu })
    }
  },
  mounted() {
    // 监听页面滚动
    window.addEventListener('scroll', this.handleScroll)
  },
}
</script>
<style scoped>
.nav-link-active a {
  color: #106eea;
}
.code-image {
  margin-left: 0.5rem;
}
.logo {
  position: relative;
}
.code-image-box {
  position: absolute;
  right: -5rem;
  z-index: 999;
  background: #fafafa;
  box-shadow: 0px 0.0625rem 0.625rem rgba(73, 73, 73, 0.25);
}
.code-image-box img {
  width: 10rem;
}
@media (max-width: 768px) {
  .code-image {
    width: 1.3125rem;
  }
  .code-image-box {
    top: 2rem;
    padding: 0.75rem;
  }
}
@media (min-width: 768px) {
  .code-image {
    width: 1.875rem;
  }
  .code-image-box {
    top: 2.5rem;
    padding: 1.5rem;
  }
}
</style>
